import React from 'react';
import PropTypes from 'prop-types';
import { useTransition, animated } from 'react-spring';

const Hours = ({ hours, hoursSelect, selectedEvent }) => {
  // const [hours, setHours] = useState(null);

  const handleSelect = (eventId, hrs) => {
    // set the mapadore event
    hoursSelect(eventId, hrs);
  };

  const getSelectedClass = (item) => {
    if (selectedEvent) {
      return item.hours === selectedEvent.hours ? 'active' : '';
    } return '';
  };

  // const sortedHours = hours.slice(0);
  // sortedHours.sort((a, b) => {
  //   const x = a.hours.toLowerCase();
  //   const y = b.hours.toLowerCase();
  //   if (x < y) return -1;
  //   if (x > y) return 1;
  //   return 0;
  // });
  const transitions = useTransition(
    hours,
    (item) => `${item.mapadore_event_id}${item.hours}`,
    {
      from: { opacity: 0, transform: 'translate3d(0,10px,0)' },
      enter: { opacity: 1, transform: 'translate3d(0,0px,0)' },
      leave: { opacity: 0, transform: 'translate3d(0,10px,0)' },
    },
  );
  return (
    <>
      <p className="subtitle">Orari disponibili</p>
      <div className="hours-choice_wrapper">
        {transitions.map(({ item, props, key }) => (
          <animated.div
            role="button"
            tabIndex="0"
            key={key}
            style={props}
            className={`hours-choice_btn ${getSelectedClass(item)}`}
            onClick={() => {
              handleSelect(item.mapadore_event_id, item.hours);
            }}
            onKeyPress={() => handleSelect(item.mapadore_event_id, item.hours)}
          >
            {item.hours}
          </animated.div>
        ))}
      </div>
    </>
  );
};

Hours.propTypes = {
  hours: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  selectedEvent: PropTypes.shape({
    hours: PropTypes.string.isRequired,
  }).isRequired,
  hoursSelect: PropTypes.func.isRequired,
};
export default Hours;
